export const ACQUISITION_CONSENT = 'acquisition'
export const PORTFOLIO_CONSENT = 'portfolio'
